import { render } from "./ProjectTableHeader.vue?vue&type=template&id=374cc5bf&scoped=true"
const script = {}

import "./ProjectTableHeader.vue?vue&type=style&index=0&id=374cc5bf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374cc5bf"]])

export default __exports__